import { PresetSettingsUI } from "./presetSettingsUI";

export class PresetSettings {

  // UI
  private ui: PresetSettingsUI = new PresetSettingsUI();
  private preset: string = this.ui.presetElement.val() as string;

  public constructor(private render: (data, afterRender: () => void) => {}, private extraData, private form, private updateValues: (data) => void) {

    if (typeof extraData.extraData.cfgData !== 'undefined') {
      this.bind();
      this.handlePresetChange(this.preset);
    }
  }

  private bind() {
    this.ui.onPresetChange(this.handlePresetChange.bind(this));
  }

  private handlePresetChange(preset: string) {
    this.preset = preset;
    this.ui.resetInputs();
    this.handleChange();
  }

  private handleChange() {
    if (typeof this.extraData !== "undefined") {
      let variables: any = this.extraData.extraData.cfgData[this.preset];
      this.updateValues(this.createDataSet(variables));
    }
  }
  
  private createDataSet(data) {
    const newData = {};
    for (const key in data) {
      newData[data[key]['config']] = {}
    }
    
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key];
        newData[element.config][element.name] = element.value;
        if (element.readOnly === true) {
          const selector = "[name='config[" + element.config + "][" + element.name + "]']";
          if ($(selector).parents('.fancy-checkbox').length > 0) {
            $(selector).parents('.fancy-checkbox').addClass('is-disabled');
          } else {
            $(selector).attr('disabled', 'disabled');
          }
        }
      }
    }
    
    return newData;
  }
}
